export const APP_NAME = "Oases Solar";
export const APP_URL = "https://app.oases-solar.com";
export const BACK_END_URL = "https://be.oases-solar.com";
//export const RECAPTCHA_SITEKEY = "6Ld0FCkTAAAAAKT5zY1P6F2K7pUzPpUskzkIZ7uD"; //localhost
export const RECAPTCHA_SITEKEY = "6LflGHYiAAAAAGC1KF21QWZTAOPhxqQ2023VTA8E"; //live

export const IDB_NAME = 'idb_oases_solar';
export const IDB_TABLES = []; //array of string (table names)